import React, { useEffect } from 'react';
import { useKeyPress } from '../../../Shared/UseKeyPress';

const useUndoRedo = (onUndo: () => void, onRedo: () => void) => {
  const undoPressed = useKeyPress('z', true);
  const redoPressed = useKeyPress('y', true);

  useEffect(() => {
    if (undoPressed) {
      onUndo();
    }
  }, [onUndo, undoPressed]);

  useEffect(() => {
    if (redoPressed) {
      onRedo();
    }
  }, [onRedo, redoPressed]);
};

export default useUndoRedo;
